import { ModalBody, Modal, ModalContent, ModalFooter, useDisclosure, Button } from "@nextui-org/react"
import { useEffect } from "react"

const ConfirmBox = ({ handleConfirmBox }) => {
    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()

    const handleDelete = () => {
        handleConfirmBox(true)
        onOpenReportModelChange();
    }

    const handleOnClose = () => {
        handleConfirmBox(false);
        onOpenReportModelChange();
    }

    useEffect(() => {
        onOpenReportModelChange()
    }, [handleConfirmBox])

    return (
        <div>
            <Modal
                isOpen={isOpenReportModel}
                onOpenChange={onOpenReportModelChange}
                size="xs"
                placement="center"
                backdrop="transparent"
                isDismissable={false}
                hideCloseButton={true}
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalBody className="overflow-auto border-t-4 border-rose-500">
                                <div className="flex  item-center justify-around text-sm mt-5 mb-2" > Sure ! You Want To Delete?</div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="warning" size="sm" variant="bordered" onPress={handleDelete}>
                                    Yes Delete !
                                </Button>
                                <Button color="danger" size="sm" variant="bordered" onPress={handleOnClose}>
                                    Cancle
                                </Button>
                            </ModalFooter>
                        </>

                    )}
                </ModalContent>
            </Modal>
        </div>
    )
}
export default ConfirmBox